<script setup lang="ts"></script>
<template>
  <v-btn
    v-bind="$attrs"
    class="opacity-100 hover:opacity-80"
    variant="plain"
    :ripple="false"
    icon="mdi-close"
    aria-label="close"></v-btn>
</template>
